<template lang="html">
  <Container hideLayout hideGlow class="laptop-container" name="howitworks">
    <div class="laptop-inside">
      <div class="laptop-field">
        <img src="../assets/img/SlideButton.svg" @click="scroll('laptopCarousel', 'prev')">
      </div>
      <div class="laptop-content">
        <div class="laptop">
          <div class="display">
            <VueSlickCarousel
              ref="laptopCarousel"
              :arrows="false"
              :slidesToShow="1"
              :infinite="true"
              :autoplay="false"
              :autoplaySpeed="60000">
              <div class="slide" v-for="(slide, i) in slides" :key="i">
                <img
                  :src="require(`../assets/img/screenshots/computer/${slide.img}`)"
                  class="screenshot">
                <div class="content">
                  <div class="text-container">
                    <div class="text">
                      <h1>{{slide.header}}</h1>
                      <p v-html="slide.text"></p>
                    </div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
          <img src="../assets/img/laptop.png" class="placeholder">
        </div>
      </div>
      <div class="laptop-field">
        <img src="../assets/img/SlideButton.svg" @click="scroll('laptopCarousel')">
      </div>
    </div>
  </Container>
</template>

<script>
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import VueSlickCarousel from 'vue-slick-carousel'
import Container from '../components/Container'

export default {
  components: { VueSlickCarousel, Container },
  data: () => ({
    slides: [{
      img: '01.png',
      header: 'Электролаборатория',
      text: `<ul>
        <li>Автоматическое составление отчета</li>
        <li>Контроль пропускания тока</li>
        <li>Контроль срабатывания приборов</li>
        <li>Проверка заземлением</li>
        <li>Измерение заземления между приборами и проводниками</li>
        <li>Контроль металлосвязи</li>
        <li>Измерение сопротивления проводки, изоляции, автоматов и защитных узлов</li>
        <li>Указание / знание / уведомление / поиск "прожига" кабелей</li>
      </ul>`
    },{
      img: '02.png',
      header: 'Аварийная сигнализация',
      text: '<h2 style="">и управление тревожными сообщениями</h2>'
    },{
      img: '03.png',
      header: 'База данных',
      text: '<h2>реального времени с технологической информацией</h2>'
    },{
      img: '04.png',
      header: 'Качество электроэнергии',
      text: `<ul>
        <li>отклонение напряжения (δU, %);</li>
        <li>размах изменения напряжения (δUt, %);</li>
        <li>доза колебаний напряжений (ψ, %);</li>
        <li>коэффициент несинусоидальности кривой напряжения (kнсU, %);</li>
        <li>коэффициент n-й гармонической составляющей напряжения нечетного (четного) порядка (kU(n), %);</li>
        <li>коэффициент обратной последовательности напряжений (k2U, %);</li>
        <li>коэффициент нулевой последовательности напряжений (k0U, %);</li>
        <li>длительность провала напряжения (Δtпр, с);</li>
        <li>импульсное напряжение (Uимп, В, кВ);</li>
        <li>отклонение частоты (Δf, Гц).</li>
      </ul>`
    },{
      img: '05.png',
      header: 'Мониторинг работы электросети',
      text: '<p>Определение неисправности в работе электросети и их устранение. Предотвращение возгорания проводки, получения трвам, выхода из строя оборудования</p>'
    },{
      img: '06.png',
      header: 'Предиктивные функции',
      text: '<p>Выявление и диагностика проблем оборудования до наступления события отказа. Сокращение простоев. Повышение надежности и производительности. Сокращение затрат на техобслуживание и эксплуатацию</p>'
    },{
      img: '01.png',
      header: 'Управление энергопотреблением',
      text: `<ul>
        <li>Формирование отчета в режиме реального времени;</li>
        <li>Отображение графиков энергопотребления(день/месяц/квартал/год);</li>
        <li>По-объектный учет;</li>
        <li>Визуализация показателей энергопотребления;</li>
        <li>Уведомление о неэффективном использовании;</li>
        <li>Уведомление о расхождении с плановыми показателями;</li>
      </ul>`
    },{
      img: '02.png',
      header: 'Регистрация',
      text: '<h2>фактического расхода электроэнергии и целевой нагрузки.</h2>'
    },{
      img: '03.png',
      header: 'График электропостребления',
      text: '<p>отражающий в интегральном виде характер и динамику на различных объектах (группах) в режиме сопоставления друг с другом и возможностью выбора интервала наблюдения</p>'
    },{
      img: '04.png',
      header: 'Управление',
      text: '<h2>инженерными системами зданий</h2>'
    },{
      img: '05.png',
      header: 'Сервисное обслуживание',
      text: `<ul>
        <li>Отображение неработающих каналов;</li>
        <li>Сбои питания;</li>
        <li>Нарушение в работе электрооборудования;</li>
        <li>Отклонения от заданных параметров;</li>
      </ul>`
    },{
      img: '06.png',
      header: 'Энергоаудит',
      text: `<h2>Баланс электрической энергии</h2>`
    }]
  }),
  methods: {
    scroll(ref, direction) {
      let carousel = this.$refs[ref];
      if (direction == "prev") {
        carousel.prev()
      } else { carousel.next() }
    }
  }
}
</script>

<style lang="css" scoped>
  @media screen and (max-width: 800px) {
    .laptop-container { display: none; }
  }
  /* @media screen and (max-width: 1024px) {
    .laptop-container { display: none; }
  } */
  /* @media screen and (max-width: 900px) {
    /deep/ .text p {
      font-size: 12px;
    }
    /deep/ .text h1 {
      font-size: 32px;
    }
    /deep/ .text h2 {
      font-size: 21px;
    }
  } */
  @media screen and (min-width: 900px), and (max-width: 1200px) {
    /deep/ .text p {
      font-size: 14px;
    }
    /deep/ .text h1 {
      font-size: 32px;
    }
    /deep/ .text h2 {
      font-size: 24px;
    }
  }
  @media screen and (min-width: 1200px), and (max-width: 1450px) {
    /deep/ .text p {
      font-size: 16px;
    }
    /deep/ .text h1 {
      font-size: 48px;
    }
    /deep/ .text h2 {
      font-size: 24px;
    }
  }
  @media screen and (min-width: 1450px) {
    /deep/ .text p {
      font-size: 21px;
    }
    /deep/ .text h1 {
      font-size: 52px;
    }
  }
  .laptop-inside {
    /* display: inline-block; */
    position: relative;
    width: 100%;
  }
  .laptop-content {
    position: relative;
    display: inline-block;
    width: 80%;
    margin: 0 10%;
    padding-top: 15vh
  }
  /* .laptop-field {
    width: 10%;
  } */
  /* .laptop-field:first-child * {
    transform: translate(50%,0);
    float: right;
  }
  .laptop-field:last-child * {
    transform: translate(-50%,0);
  } */
  /* .laptop-field:last-child { float: right }
  .laptop-field:first-child { float: left } */

  .laptop {
    position: relative;
    width: 90%;
    max-width: 1200px;
    margin: auto;
  }
  .placeholder {
    /* width: 50vw; */
    width: 100%;
    max-height: 800px;
    /* height: 0%; */
    /* position: relative; */
    /* position: absolute; */
  }
  .content {
    /* background-color: red; */
    position: absolute;
    /* position: relative; */
    top: 0;
    width: 100%;
    height: 100%;
    transition: .2s;
    /* background-color: #0d0d0e; */
    opacity: 0;
    /* padding: 20px; */
  }
  .text-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* background-color: green; */
  }
  .text {
    position: absolute;
    width: 3.6%;
    top: 50%;
    left: 2%;
    ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
  }
  /deep/ .text p {
    text-align: center;
    /* font-size: 21px; */
  }
  /deep/ .text ul {
    /* list-style-type: none; */
    padding: 0;
    text-align: left;
  }
  /deep/ .text h1 {
    /* font-size: 3.5em; */
    /* font-size: 70px; */
    color: #0303D2;
  }
  /deep/ .text h1, /deep/ .text h2 {
    text-align: center;
  }
  .screenshot {
    width: 100%;
    transition: .2s;
  }
  .display {
    position: absolute;
    top: 7%;
    left: 11.5%;
    width: 77%;
    height: 86%;
    background-color: #0d0d0e;
    overflow-y: hidden;
    cursor: pointer;
    /* border: 1px solid red; */
  }
  .slide:hover .screenshot {
    opacity: 0;
  }
  .slide:hover .content {
    opacity: 1;
  }
  .laptop-field {
    height: 100%;
    position: absolute;
    width: 10%;
    top: 0;
  }
  .laptop-field:first-child { left: 0; }
  .laptop-field:last-child { right: 0; }
  .laptop-field img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-150%,-50%);
    cursor: pointer;
    z-index: 99;
  }
  .laptop-field:first-child img {
    transform: rotate(180deg) translate(-50%,50%);
  }
</style>
